export default __webpack_public_path__ + "static/media/filter_icon_all.8171c5a1.svg";